<div class="col-md-12 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 row m-0 lob-padding">
    <div class="col-md-9 col-sm-12 col-lg-9 col-xl-9 col-xs-9 selectBy-label-padding" style="align-items: center;">
         <mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="selectionTypeChange($event)">
          <mat-tab *ngFor="let tab of tabs" [label]="tab.label"> </mat-tab>
        </mat-tab-group>
    </div>
    <div class="stk-nav col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xs-3 p-0">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-rightAlign" style="margin-bottom: 0px; padding: 1.5% 0px 0px 0px;">
                <li class="breadcrumb-item"><a class="breadcrumb-home" [routerLink]="['/landing-page']">Home</a></li>
                <li *ngIf="selectedOption==='lob'" class="breadcrumb-item active" aria-current="page">LOB Maintenance</li>
                <li *ngIf="selectedOption==='org'" class="breadcrumb-item active" aria-current="page">Organization Maintenance</li>
                <li *ngIf="selectedOption==='decom_lob'" class="breadcrumb-item active" aria-current="page">Decom LOB</li>
                <div>
                    <button [attr.Pixel-tracking]="true" [attr.Pixel-title]="'Documentation'"
                        class="breacrum-info-button uitk-icon uitk-icon-info_hollow health md-icon for-media excelandinfo-Icon-font info-icon"
                        matTooltipPosition="left" title="Info" (click)="showInfo()">
                    </button>
                </div>
            </ol>
        </nav>
    </div>
</div>

<div [hidden]="selectedOption!='lob' && !showLoader" >
            <div class="lob-model-view">
                <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
                    <div class="uitk-c-card uhc-font">
                        
                                        <div class="uitk_new_header">
                                            <div class="uitk-l-grid__col--12 stk-container-tabl-header">
                                                <div class="stk-header-action row">
                                                    
                                                    <div class="table-header-icons col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
                                                        <ng-container *ngIf="dataSourceDetails && dataSourceDetails.data.length">
                                                            <div class="table-search col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-6">
                                                                <mat-form-field class="data-filter" appearance="outline" style="padding: 0px;">
                                                                    <input [(ngModel)]="searchField" matInput type="text"
                                                                        class="capability-search"
                                                                        placeholder="Search Segment/LOB/SubLOB/Architect Names"
                                                                        (keyup)="searchDataSet($event)">
                                                                    <img src="../../../../assets/images/searchicon.png" class="lob-view-search-img"/>
                                                                </mat-form-field>
                                                            </div>
                                                        </ng-container> 
                                                        &nbsp;
                                                        <div class="table-header-icons table-header-icons-buttons col-md-8 col-sm-6 col-lg-8 col-xl-8 col-xs-6">
                                                            <ng-container *ngIf="TABLE_CONFIG.edit && dataSourceDetails && dataSourceDetails.data.length"> 
                                                                <button (click)="AddNewEntry()" class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs">Add</button>
                                                            </ng-container>
                                                            
                                                            <div *ngIf="TABLE_CONFIG.edit  && dataSourceDetails && dataSourceDetails.data.length"> 
                                                                <button (click)="showAddRemoveCAPopup()" class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs">Add / Remove CA/AD</button>
                                                            </div>
                                                            <ng-container *ngIf="dataSourceDetails && dataSourceDetails.data.length"> 
                                                                <button (click)="expandAllFunc()" class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs">{{allRowsExpanded ? 'Collapse All' : 'Expand All'}}</button>
                                                            </ng-container>
                                                             &nbsp;
                                                            <div *ngIf="dataSourceDetails && dataSourceDetails.data.length"
                                                                (click)="exportToCsv()" class="export-link">
                                                                <span title="Click to Download" class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"></span>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>    
                                                </div>
                                            </div>
                                        </div>
                                        <div class="uitk-c-card__content" style="margin-top: 0px !important;">
                                            <div class="stk-table-container">
                                                <div class="stk-table-loader" *ngIf="showLoader">
                                                    <app-loader>
                                                    </app-loader>
                                                </div>
                                                <div class="stk-table-loader partial-loader" *ngIf="partialLoader">
                                                    <app-loader>
                                                    </app-loader>
                                                </div>
                                                <div class="stk-table-loader lob-loader" *ngIf="lobLoader">
                                                    <app-loader>
                                                    </app-loader>
                                                </div>                                                
                                                <ng-container *ngIf="!showLoader">
                                                    <app-maintenance-table-v4 [TABLE_CONFIG]="TABLE_CONFIG" [COLUMNS]="TABLE_COLUMNS"
                                                        [expanded_columns]="expanded_columns" (reloadData)="handleAppicationload()"
                                                        [SORT_CONFIG]="sortConfig" [dataSource]="dataSourceDetails"
                                                        [childDataSource]="dataSourceDetails"
                                                        [SCHEMA]="DATA_SCHEMA" 
                                                        (searchEvent)="searchEvent($event)" (saveEvent)="saveEvent($event)"
                                                        (CreateEvent)="CreateEvent($event)" (checkBoxEvent)="checkBoxEvent($event)"
                                                        [pageSize]="TABLE_CONFIG.pageSize" [pageIndex]="TABLE_CONFIG.pageIndex" 
                                                        [expandAll]="expandAll" [exportToExcel]="exportToExcel"
                                                        [selectedOption]="selectedOption"
                                                        (columnDataSubLob)="subLobEditClicked($event)" (collapseAll)="collapseAllFunc($event)"
                                                        (ColomnDataLob)="LobEditClicked($event)" (loadDeletePopup)="loadDeletePopup($event)">
                                                    </app-maintenance-table-v4>
                                                </ng-container>
                                            </div>
                                        </div>
                                   
                    </div>
                </div>
            </div>
      
    
</div>
<div [hidden]="selectedOption!='org'">
    <app-org-maintenance-v4></app-org-maintenance-v4>
</div>
<div *ngIf="selectedOption=='decom_lob' && decomAccessLoaded">
    <app-decom-lob [DecomLobViewAccess]="DecomLobViewAccess" [DecomLobEditAccess]="DecomLobEditAccess"></app-decom-lob>
</div>

<app-modal [maximizable]="true" [inViewport]="true" #modalAddLob class="modal-demo  lob-add-edit-popups" (closeModal)="hidepopup('add')">
        <ng-container class="app-modal-header">Add LOB / Sub LOB</ng-container>
        <ng-container class="app-modal-body">
            <app-lob-add-popup *ngIf="isNewClicked" [isNewClicked]="isNewClicked" [dataSource]="dataSourceFull"
            (AddLobDataEmitter)="applyAddLob($event)">
            </app-lob-add-popup>
        </ng-container>
</app-modal>

<app-modal [maximizable]="true" [inViewport]="true" #modalEditSubLob class="modal-demo lob-add-edit-popups" (closeModal)="hidepopup('editSubLob')">
    <ng-container class="app-modal-header">Edit Sub LOB</ng-container>
    <ng-container class="app-modal-body">
        <app-lob-add-popup *ngIf="isSubLobEditClicked" [isSubLobEditClicked]="isSubLobEditClicked" [EditColumnDataSubLob]="EditColumnDataSubLob" 
        (EditSubLobDataEmitter)="applyEditSubLob($event)" (clearSearch)="searchClear()">
        </app-lob-add-popup>
    </ng-container>
</app-modal>

<app-modal [maximizable]="true" [inViewport]="true" #modalEditLob class="modal-demo lob-edit" (closeModal)="hidepopup('editLob')">
    <ng-container class="app-modal-header">Edit LOB</ng-container>
    <ng-container class="app-modal-body">
        <app-lob-add-popup *ngIf="isLobEditClicked" [isLobEditClicked]="isLobEditClicked" [EditColumnDataLob]="EditColumnDataLob"
        (EditLobDataEmitter)="applyEditLob($event)">
        </app-lob-add-popup>
    </ng-container>
</app-modal>

<app-modal  [maximizable]="true" [inViewport]="true" #deleteModel class="modal-delete" (closeModal)="hidepopup('deleteSubLob')">
    <ng-container *ngIf="isDeleteClicked" class="app-modal-header">Delete Sub LOB : {{deleteSelectedSubLob.SubLineofBusiness}}</ng-container>
    <ng-container class="app-modal-body">
      <app-delete-lob *ngIf="isDeleteClicked" [isDeleteClicked]="isDeleteClicked" [deletedRow]="deleteSelectedSubLob" 
      [lobDatasource]="dataPersistObj.data" (deleteSuccessEvent)="hideDeletePopup()">
      </app-delete-lob>
    </ng-container>
</app-modal>

<app-modal  [maximizable]="true" [inViewport]="true" #bulkModel class="modal-delete" (closeModal)="hidepopup('bulkEdit')">
    <ng-container *ngIf="isBulkClicked" class="app-modal-header">Bulk Edit</ng-container>
    <ng-container class="app-modal-body">
      <app-lob-bulk-edit *ngIf="isBulkClicked" (bulkSuccessEvent)="hideBulkPopup()">
      </app-lob-bulk-edit>
    </ng-container>
</app-modal>

<app-modal id="addRemoveCAModel"  [maximizable]="true" [inViewport]="true" #addRemoveCAModel class="modal-delete" (closeModal)="hidepopup('addRemoveCA')">
    <ng-container *ngIf="isAddRemoveClicked" class="app-modal-header">Add / Remove CA/AD</ng-container>
    <ng-container class="app-modal-body">
    <app-add-remove-popup (addRemoveSuccessEvent)="hideaddRemovePopup()" *ngIf="isAddRemoveClicked" [dataSource]="dataSourceFull" [popupName]="'AddRemoveArchitect'" [clearFormFields]="clearFormFields">
    </app-add-remove-popup>
    </ng-container>
</app-modal>